 
import _ from 'lodash';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { productEffects } from 'shared/constants';

type EffectsValueMap = Record<string, number | null>;

// default effects to camelCase
export const effectsKeys = productEffects.map((effect: string) => _.camelCase(effect));

// map of effect keys to labels
export const translatedEffectNames: Record<typeof productEffects[number], string> = {
  calm: 'Calm',
  clearMind: 'Clear Mind',
  creative: 'Creative',
  energetic: 'Energetic',
  focused: 'Focused',
  happy: 'Happy',
  inspired: 'Inspired',
  relaxed: 'Relaxed',
  sleepy: 'Sleepy',
  uplifted: 'Uplifted',
};

const camelCaseObjectKeys = (obj: Record<string, any>): Record<string, any> =>
  _.mapKeys(obj, (value, key) => _.camelCase(key));

// builds a camelCase map of effect keys with their values
// if an effect is not present in the map, it is set to 0
export const cleanEffects = (effectsValueMap: EffectsValueMap): EffectsValueMap => {
  // normalized effects map with camelCase keys to match the default keys
  const camelEffectsValueMap: EffectsValueMap = camelCaseObjectKeys(effectsValueMap);
  // builds a new effects map with the default keys existing values or 0
  const cleanedEffects = effectsKeys.reduce((acc: EffectsValueMap, key: keyof EffectsValueMap) => {
    const effectValue = camelEffectsValueMap[key];
    const defaultEffectValue = { ...acc, [key]: 0 };
    if (_.isNil(effectValue)) {
      return defaultEffectValue;
    }

    const number = parseInt(`${effectValue}`, 10);

    if (!_.isFinite(number)) {
      return defaultEffectValue;
    }

    return { ...acc, [key]: number };
  }, {});
  return cleanedEffects;
};

export type StrainTypes = 'High CBD' | 'Hybrid' | 'Indica' | 'Sativa';
type EffectsDefaults = Record<StrainTypes, Partial<EffectsValueMap> | undefined>;

const effectsOptions = _.fromPairs(
  Object.entries(productEffects).map(([idx, effectName]) => [_.camelCase(effectName as any), Number(idx)])
);
const initialEffectValues: EffectsValueMap = _.mapValues(effectsOptions, _.constant(0));

export const defaultEffects: EffectsDefaults = {
  Indica: {
    relaxed: 9,
    sleepy: 8,
    happy: 8,
    euphoric: 8,
  },
  Sativa: {
    energetic: 9,
    happy: 9,
    creative: 8,
    focused: 8,
    inspired: 8,
  },
  Hybrid: {
    calm: 9,
    happy: 8,
    relaxed: 6,
    energetic: 5,
  },
  'High CBD': {
    clearMind: 9,
    calm: 8,
    relaxed: 5,
    happy: 5,
  },
};

export function getDefaultEffectsForStrainType(strainType: string): EffectsValueMap {
  const defaultValues = defaultEffects[strainType as StrainTypes] ?? {};
  return { ...initialEffectValues, ...defaultValues } as EffectsValueMap;
}
